module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "center4"
  }, [_c('span', [_c('em', [_vm._v("For Mother")])])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "center1"
  }, [_c('span', [_vm._v("“To the living, one owes consideration;")])]), _vm._v(" "), _c('p', {
    staticClass: "center2"
  }, [_c('span', [_vm._v("to the dead, only the truth.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', [_c('span', {
    staticClass: "small-caps"
  }, [_vm._v("—VOLTAIRE")]), _vm._v(" "), _c('em', [_vm._v("(Lettres Sur Oedipe)")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6fb4c34f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dedication.vue
// module id = 69
// module chunks = 0